// extracted by mini-css-extract-plugin
export default {"box":"ServiceHome_box__UssPr","heading":"ServiceHome_heading__Z3hxU","text":"ServiceHome_text__pwvms","to":"ServiceHome_to__Jl930"};